import { render, staticRenderFns } from "./cnzbb.vue?vue&type=template&id=47b6d69f&scoped=true&"
import script from "./cnzbb.vue?vue&type=script&lang=js&"
export * from "./cnzbb.vue?vue&type=script&lang=js&"
import style0 from "./cnzbb.vue?vue&type=style&index=0&id=47b6d69f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6d69f",
  null
  
)

export default component.exports